import { useMemo } from 'react';
import { COUNTRY_CODES } from 'fym-shared/src/geo/countryCodes';
import { useQueryParam } from '../../../utils/hooks/useQueryParam';
import { allCountriesValue, countryParamName } from '../components/SMLCountrySelector/consts';

export const useSMLCountryParam = () => {
  const countryParam = useQueryParam(countryParamName, null, '');
  const countryCode = useMemo(() => {
    const raw = (countryParam ?? '').toUpperCase();
    if (raw === '' || raw === allCountriesValue) {
      return undefined;
    }
    return COUNTRY_CODES.includes(raw) ? raw : undefined;
  }, [countryParam]);
  return { countryCode, countryParamValue: countryCode ?? allCountriesValue };
};
